// get wishlist items from local storage
export const getWishlistItems = () => {
  const wishlistItems = localStorage.getItem('wishlist');
  return wishlistItems ? JSON.parse(wishlistItems) : [];
};

// check if the item is in the wishlist
export const isInWishlist = (product_id) => {
  const wishlistItems = getWishlistItems();
  return wishlistItems.some(item => item.product_id === product_id);
};


// get the wishlist item by product_id
export const getWishlistItem = (product_id) => {
  const wishlistItems = getWishlistItems();
  return wishlistItems.find(item => item.product_id === product_id);
};
